import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
    const layoutStyle = {
        display: "flex",
        flexDirection: "column",
        minHeight: "98vh",
    };

    const contentWrapperStyle = {
        flexGrow: 1,
        overflowY: "auto",
        height: "calc(100vh - 276px)",
    };

    return (
        <div style={layoutStyle}>
            <h1 className="visually-hidden">{"Application"}</h1>
            <header>
                <Header />
            </header>
            <main style={contentWrapperStyle}>
                <Outlet />
            </main>
            <footer>
                <Footer />
            </footer>
        </div>
    );
};

export default Layout;
